/* eslint-disable prefer-destructuring */
<template>
  <div class="doc-page-container">
    <div class="page-main">
      <div id="lbs-header" />
      <div class="page-content-container">
        <div class="page-left-wrapper">
          <div
            id="sidebar-wrapper"
            class="sidebar-wrapper"
          >
            <div class="page-title">
              <!-- eslint-disable -->
              <span v-html="title" />
            </div>
            <div class="sidebar-container">
              <Sidebar
                :nav-list="formatedNavList"
                :default-path="$route.path"
                :opened-depth="sidebarOpenedDepth"
              />
            </div>
          </div>
        </div>
        <div class="page-right-wrapper" :class="isAnchor ? 'mr200': ''">
            <div class="page-article-container" :class="isFaq ? 'mt12': ''">
            <div v-if="!isFaq" class="page-breadcrumb" v-html="breadcrumb">
              <!-- {{ breadcrumb }} -->
            </div>
            <!-- eslint-disable -->
            <div
              v-html="html"
              class="article-container custom-html-style"
            />
            <div v-if="!isFaq && showFeedback" class="help-container">
              <h2 class="help-h">
                这篇文章对您解决问题是否有帮助？
              </h2>
              <div class="help-radio-group">
                <div
                  :class="['help-radio-item', 'solved', isHelp === 1 ? 'active' : '']"
                  @click="onHelp(1)"
                >
                  <span v-if="!isSubmitFeedback">已解决</span>
                  <span v-if="isSubmitFeedback && !isSuccessFeedback">提交成功，感谢您的反馈！</span>
                  <span v-if="isSubmitFeedback && isSuccessFeedback">我们已收到您的反馈，抱歉未能解决您的问题，我们将继续努力！</span>
                </div>
                <div
                  v-if="!isSubmitFeedback"
                  :class="['help-radio-item', 'unsolved', isHelp === 0 ? 'active' : '']"
                  @click="onHelp(0)"
                >
                未解决
                </div>
              </div>
              <div class="help-feedback" v-if="!isHelp">
                <h2 class="help-h feedback-h">
                  <span class="feedback-require">*</span> 请选择您遇到的问题
                </h2>
                <div class="help-feedback-item help-feedback-checkbox">
                  <el-checkbox-group v-model="feedbackCheckList">
                    <div class="help-feedback-checkbox-item">
                      <el-checkbox label="内容错误/链接错误"></el-checkbox>
                      <el-checkbox label="内容不完整/不详细"></el-checkbox>
                      <el-checkbox label="结构混乱/逻辑不清"></el-checkbox>
                    </div>
                    <div class="help-feedback-checkbox-item">
                      <el-checkbox label="内容更新不及时"></el-checkbox>
                      <el-checkbox label="缺少代码/图片示例"></el-checkbox>
                      <el-checkbox label="其他"></el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <h2 class="help-h feedback-h">
                    详细问题描述，如您遇见技术问题，请<a :href="orderUrl" target="_blank">提交工单</a>
                </h2>
                <div class="help-feedback-item help-feedback-recommend">
                  <el-input
                  type="textarea"
                  placeholder="请描述您使用文档过程中的问题或改进意见"
                  v-model="feedbackRecommend"
                  maxlength="500"
                  show-word-limit
                  resize="none"></el-input>
                </div>
                <div class="help-feedback-submit">
                  <el-button type="primary" @click="onSubmitFeedback">提交反馈</el-button>
                </div>
              </div>
            </div>
          </div>
          <div id="lbs-footer">Copyright © 1998-{{new Date().getFullYear()}} Tencent All Rights Reserved 腾讯公司版权所有</div>
        </div>
      </div>
    </div>
    <anchor-nav v-if="isAnchor" :anchorList="anchorList" :offsetTop="anchorTop"></anchor-nav>
  </div>
</template>

<script>
import http from '~/utils/http';
import beaconRequest from '~/utils/beaconRequest';
import util from '~/utils/index';
import Sidebar from '~/components/doc-sidebar';
import AnchorNav from '~/components/anchor-nav';
import Check from '~/utils/loginCheck';
import { login } from '~/utils/login';
import { getCategoryInfoApi, getCategoryListApi, getArticleListApi, getArticleContentApi } from '~/service/doc-service';
import { errorLogger } from '~/utils/logger';

const ORDER_MAP = {
  javascriptGL: '/dev/console/ticket/create?name=JavaScriptAPI GL',
  visualizationApi: '/dev/console/ticket/create?name=数据可视化API',
  javascriptV2: '/dev/console/ticket/create?name=Javascript API',
  component: '/dev/console/ticket/create?name=地图组件',
  uriV1: '/dev/console/ticket/create?name=URI API',
  androidLocationSDK: '/dev/console/ticket/create?name=Android定位SDK',
  iosLocationSDK: '/dev/console/ticket/create?name=iOS定位SDK',
  unityGeo: '',
  androidMapSDK: '/dev/console/ticket/create?name=Android地图SDK',
  iOSMapSDK: '/dev/console/ticket/create?name=iOS地图SDK',
  webService: '/dev/console/ticket/create?name=WebService API',
  placeCloud: '/dev/console/ticket/create?name=地点云',
  jsSdk: '/dev/console/ticket/create?name=微信小程序SDK',
  plugin: '/dev/console/ticket/create?name=微信小程序插件',
  unitySdk: ''
};

const URL_PR = 'https://pr.map.qq.com/pingd';
const PATH_MAP = {
  faq: 'faq'
};
const TYPE_MAP = {
  DIR: 1,
  ARTICLE: 2
};

const SUBTITLE_TYPE = 1;

export default {
  name: 'Page',
  components: {
    Sidebar,
    AnchorNav
  },
  layout: 'default',
  middleware: 'handleHost',
  // eslint-disable-next-line complexity
  async asyncData({ params, error, navInit, script, showFeedback, sidebarOpenedDepth, userAgent }) {
    try {
      const pathArr = params.pathMatch.split('/').filter(path => !!path);
      let categoryInfo = {}; let navList = []; let currentPathInfo = {};
      if (!pathArr.length) {
        error({
          statusCode: 404,
          message: '404 Not Found'
        });
        return;
      }
      // 判断路由层级
      let pathUrl = '';
      switch (pathArr[0]) {
        case PATH_MAP.faq:
          // eslint-disable-next-line prefer-destructuring
          pathUrl = `/${pathArr[0]}`;
          break;
        default:
          // eslint-disable-next-line prefer-destructuring
          pathUrl = `/${pathArr[0]}/${pathArr[1]}`;
          break;
      }
      // 工单映射
      const orderUrl = ORDER_MAP[pathArr[1]] ? ORDER_MAP[pathArr[1]] : '/dev/console/ticket/categories';
      [categoryInfo, currentPathInfo, navList] = await Promise.all([
        getCategoryInfoApi({ path_map: pathUrl }), // 获取目录信息
        getCategoryInfoApi({ path_map: `/${pathArr.join('/')}` }), // 获取目录信息
        getCategoryListApi({ level: 5, path_map: pathUrl }),
      ]);
      const parentId = currentPathInfo.category_id;
      // 获取文章列表
      const res = await getArticleListApi({ parent_id: parentId });
      let html = '';
      let isAnchor = 0;
      if (Array.isArray(res) && res.length) {
        // 获取文章id和文章内容
        const articleId = res[0].article_id;
        const contentRes = await getArticleContentApi({ parent_id: parentId, article_id: articleId });
        const content = contentRes.html_content;
        if (content) {
          html = content;
        }
        isAnchor = res[0].is_show_anchor;
      }
      return {
        pathUrl,
        navList: Array.isArray(navList.categorys) ? navList.categorys : [],
        title: categoryInfo.name || '',
        html,
        orderUrl,
        isAnchor,
        navInit,
        script,
        showFeedback,
        sidebarOpenedDepth,
        userAgent,
      };
    } catch (err) {
      console.error(err);
      errorLogger(err);
    }
  },
  data() {
    return {
      navList: [],
      title: '',
      html: '',
      isCollapseTransition: false,
      isHelp: -1,
      isSuccessFeedback: false,
      anchorList: [],
      // isAnchor: true,
      anchorTop: 54,
      feedbackCheckList: [],
      feedbackRecommend: '',
      isSubmitFeedback: false,
      isFaq: false,
      downloadDomArr: [],
      formatedNavList: [],
      pathNameArr: [],
    };
  },
  computed: {
    pathArr() {
      return this.$route.params.pathMatch.split('/').filter(path => !!path);
    },
    breadcrumb() {
      return this.pathNameArr.join(' / ');
    },
  },
  watch: {
    '$route.path'() {
      // v-html在nexttick后，宏任务前更新
      setTimeout(this.runScript, 0);
    },

  },
  created() {
    if (this.$route.path.indexOf(`${PATH_MAP.faq}/`) !== -1) {
      this.anchorTop = 12;
      this.isFaq = true;
    }
    this.pathNameArr = [this.title];
    this.setPathNameArr(this.navList, this.isFaq ? 1 : 2);
    this.formatedNavList = this.handelNavList(this.navList, this.pathUrl);
  },
  mounted() {
    util.initPageComponents(this.navInit);
    this.runScript();
    loadRobotScript();
    this._loadStatasScript();
    this.goAnchor();
    setTimeout(() => {
      this.showCurrentSidebar();
    });
    const dom = document.querySelectorAll('h2');
    this.anchorList = [];
    dom.forEach(item => {
      if (item.hasAttribute('id')) {
        this.anchorList.push({
          name: item.innerText,
          id: item.getAttribute('id')
        });
      }
    });
    if (!this.anchorList.length) {
      this.isAnchor = false;
    }
    this.$nextTick(() => {
      document.addEventListener('click', this.sendEventPv);
    });
    beaconRequest('show_docs_page', { name: this.breadcrumb, path: this.$route.path }, this.userAgent);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.sendEventPv);
  },
  methods: {
    sendEventPv(evt) {
      const dom = evt.target;
      if (dom.id && dom.id.indexOf('lbs_product') !== -1 &&
      dom.id.indexOf('lbs_event') !== -1) {
        http({
          url: `${URL_PR}?${dom.id}`,
        });
      }
    },
    handelNavList(navListData, path) {
      return navListData
        .filter(nav => {
          if (nav.type === TYPE_MAP.DIR &&  (nav.is_subtitle === SUBTITLE_TYPE || (nav.sub_categorys && nav.sub_categorys.length))) {
            return true;
          } else if (nav.type === TYPE_MAP.ARTICLE &&
            nav.sub_categorys[0] &&
            nav.sub_categorys[0].is_show_sidebar === 1) {
            return true;
          }
          return false;
        })
        .map(nav => {
          const pathMap = nav.path_map;
          return {
            title: nav.name,
            path: this.isExternalLink(pathMap) ? pathMap : `${path}/${pathMap}`,
            isGroupTitle: nav.is_subtitle === 1,
            subNavList: this.handelNavList(nav.sub_categorys, `${path}/${pathMap}`)
          };
        });
    },
    setPathNameArr(navListData, recursionNum = 2) {
      if (!navListData || !Array.isArray(navListData)) return;
      for (const nav of navListData) {
        const pathMap = nav.path_map;
        if (pathMap && pathMap === this.pathArr[recursionNum]) {
          this.pathNameArr.push(nav.name);
          if (nav.type === TYPE_MAP.DIR) {
            recursionNum += 1;
            this.setPathNameArr(nav.sub_categorys, recursionNum);
          }
          break;
        }
      }
    },
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
    showCurrentSidebar() {
      const $sidebarContent = $('.sidebar-wrapper');
      const $current = $sidebarContent.find('.el-menu-item.is-active');
      const liHeight = $current.height();
      const top = $current.length > 0 &&
      $current.position &&
      $current.position().top !== undefined  ? $current.position().top : 0;
      $sidebarContent.scrollTop(top - liHeight);
    },
    onHelp(value) {
      if (value === this.isHelp) return;
      this.isHelp = value;
      if (value) {
        this.isSubmitFeedback = true;
      }
      // 发送统计请求
      http({
        url: URL_PR,
        data: {
          appid: 'doc_help',
          is_help: value,
          name: this.breadcrumb
        }
      });
    },
    onSubmitFeedback() {
      Check.check(async ()=> {
        try {
          // eslint-disable-next-line max-len
          if (this.feedbackCheckList.length === 0) {
            this.$message({
              message: '请您填写使用文档中遇到的问题',
              type: 'warning',
              offset: 56,
              duration: 2000
            });
            return;
          }
          const res = await http({
            type: 'console',
            method: 'post',
            url: '/console/feedback?output=json',
            data: {
              title: util.formatProduct(this.breadcrumb),
              product: 37,
              doc_category: util.formatProduct(this.pathNameArr[1]),
              remarks: JSON.stringify({
                problems: this.feedbackCheckList.join(';'),
                remark: util.HTMLEncode(this.feedbackRecommend)
              })
            }
          });
          if (res.info.error === 0) {
            this.isHelp = 1;
            this.isSuccessFeedback = true;
            this.isSubmitFeedback = true;
          } else if (res.info.error === 60003 || res.info.error === 60002) {
            login();
          } else {
            console.error(res.info.msg);
          }
        } catch (error) {
          console.error(error);
        }
      }); // 检测登录
    },
    // 执行坐标拾取器的执行脚本
    runScript: async function () {
      const str = this.html;
      const ifr = document.getElementById('online_map');
      if (!ifr) {
        return;
      }

      ifr.scrolling = 'auto';

      if (!ifr.onload) {
        ifr.onload = () => {
          const height = this.calcPageHeight(idoc);
          ifr.style.height = `${height}px`;
        };
      }

      const idoc = ifr.contentDocument || ifr.contentWindow.document;

      const first = str.indexOf('<!DOCTYPE html>');
      const last = str.indexOf('</html>') + 7;
      const content = str.slice(first, last);

      const nr = content.indexOf('<body>');
      const iframeHead = content.slice(0, nr);
      const iframeFooter = content.slice(nr, content.length);

      await idoc.write(iframeHead);
      await idoc.write(iframeFooter);

      idoc.close();
    },
    // 计算iframe高度
    calcPageHeight: function (doc) {
      if (!doc && typeof doc !== 'object') {
        return 400;
      }
      if (doc.body && doc.documentElement) {
        const cHeight = Math.max(doc.body.clientHeight, doc.documentElement.clientHeight);
        const sHeight = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight);
        return Math.max(cHeight, sHeight);
      } else if (doc.body || doc.documentElement) {
        const body = doc.body || doc.documentElement;
        const cHeight = body.clientHeight;
        const sHeight = body.scrollHeight;
        return Math.max(cHeight, sHeight);
      } else if (!doc.body && !doc.documentElement) {
        return 400;
      }
    },
    _loadStatasScript() {
      const mta = document.createElement('script');
      mta.src = '//pingjs.qq.com/h5/stats.js?v2.0.4';
      mta.setAttribute('name', 'MTAH5');
      mta.setAttribute('sid', '500686541');

      const [s] = document.getElementsByTagName('script');
      s.parentNode.insertBefore(mta, s);
    },
    goAnchor() {
      const { hash } = location;
      if (hash && $(hash).length) {
        const { top } = $(hash).offset();
        $(window).scrollTop(top);
      }
    },
  },
  head() {
    return {
      title: `${this.title.split('<')[0]} | 腾讯位置服务`,
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },

};

function robotInit() {
  if (window.yzf) {
    window.yzf.init({
      sign: '37ef9b97d77206c474459abb1eb2b236b173bd763c76e979dc7c66e92811e750fb5926ee7004b2c343f789a9c9be50ec081d28',
      uid: '',
      data: {
        c1: '',
        c2: '',
        c3: '',
        c4: '',
        c5: '',
      },
      selector: '',
    });
  }
}

function loadRobotScript() {
  const script = document.createElement('script');
  // IE和opera支持onreadystatechange
  // safari、chrome、opera支持onload
  if (script.readyState) { // IE
    script.onreadystatechange = function handle() {
      if (script.readyState === 'loaded' ||
                          script.readyState === 'complete') {
        script.onreadystatechange = null;
        robotInit();
      }
    };
  } else { // 其他浏览器
    script.onload = function handle() {
      robotInit();
    };
  }
  script.src = 'https://yzf.qq.com/xv/web/static/chat_sdk/yzf_chat.min.js';
  document.getElementsByTagName('head')[0].appendChild(script);
}
</script>

<style lang="less">
@import './doc.less';

/* 机器人小助手 */
.main-contact {
  bottom: 365px!important;
  right: 0!important;
}
.main-contact .icon {
  background-image: url(./img/robot.png)!important;
  width: 18px!important;
  height: 18px!important;
  display: inline-block!important;
  vertical-align: top!important;
  margin-right: 0!important;
}
.mr200 {
        margin-right: 200px;
      }
@media (max-height: 600px), (max-width: 1000px) {
  .main-contact .chat-btn {
      background: #fff!important;
      width: 37px!important;
      height: 118px!important;
      font-size: 16px!important;
      /* padding-top: 5px!important; */
      padding: 10px 0 0 0!important;
  }
  .main-contact .chat-btn .txt {
      line-height: 20px!important;
      margin-top: 10px!important;
  }
  .main-contact .icon {
      margin: 0 auto!important;
  }
}
@media (min-height: 600px) and (min-width: 1000px) {
  .main-contact .chat-btn {
      background: #fff!important;
      width: 37px!important;
      height: 118px!important;
  }
}
@media screen and (max-width: 1329px) {
    .mr200 {
      margin-right: 0;
    }
  }
.main-contact .chat-btn .txt {
  Writing-mode: tb-rl;
  Text-align: left;
  line-height: 50px;
  color: #000;
  display: block!important;
  margin: 10px auto;
}
</style>
